import {HIDE_IN_APP_VIDEOS, SHOW_IN_APP_VIDEOS} from '@app/store/constants';

export function showInAppVideos() {
    return {
        type: SHOW_IN_APP_VIDEOS
    };
}

export function hideInAppVideos() {
    return {
        type: HIDE_IN_APP_VIDEOS
    };
}